interface PageRankBarProps {
  score: number;
  rawScore?: number;
}

export const PageRankBar = ({ score, rawScore }: PageRankBarProps) => {
  const normalizedScore = Math.min(Math.max(Math.ceil(score / 10), 0), 10);
  const percentage = (normalizedScore * 10).toFixed(0);

  return (
    <div className="flex items-center gap-2">
      <span className="font-medium">{normalizedScore}</span>
      <div className="w-[32px] h-[16px] bg-gray-200 rounded-[2px] overflow-hidden relative">
        <div 
          className="h-full bg-green-500 transition-all duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};